<div class="page-logo width-mobile-auto m-0 align-items-center justify-content-center p-0 bg-transparent bg-img-none shadow-0 height-9">
    <a href="javascript:void(0)" class="page-logo-link press-scale-down d-flex align-items-center">
        <img src="/assets/img/logo-english-coffee.png" alt="SmartAdmin WebApp" aria-roledescription="logo">
        <span class="page-logo-text mr-1">English Coffee</span>
    </a>
</div>